import { Routes } from '@angular/router';

export const content: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'firmas',
    loadChildren: () => import('../../components/firmas/firma.module').then(m => m.FirmaModule),
    data: {
      breadcrumb: "Firmas"
    }
  },
  {
    path: 'users',
    loadChildren: () => import('../../components/users/users.module').then(m => m.UsersModule),
    data: {
      breadcrumb: "Users"
    }
  },
  {
    path: 'groups',
    loadChildren: () => import('../../components/groups/groups.module').then(m => m.GroupsModule),
    data: {
      breadcrumb: "Groups"
    }
  },
  {
    path: 'perfil',
    loadChildren: () => import('../../components/perfil/perfil.module').then(m => m.PerfilModule),
    data: {
      breadcrumb: "Perfil"
    }
  },
  {
    path: 'parametros' , 
    loadChildren: () => import('../../components/parametros/parametros.module').then(m => m.ParametrosModule),
    data: {
      breadcrumb: "Parametros"
    }
  },
  {
    path: 'signature-size' , 
    loadChildren: () => import('../../components/signature-size-mto/signature-size-mto-routing.module').then(m => m.SignatureSizeMtoRoutingModule),
    data: {
      breadcrumb: "Tamaño firmas"
    }
  },
  {
    path: 'institucion',
    loadChildren: () => import('../../components/institucion/institucion.module').then(m => m.InstitucionModule),
    data: {
      breadcrumb: "Institución"
    }
  },
  {
    path: 'documentos-por-firmar',
    loadChildren: () => import('../../components/documentos-por-firmar/documentos-por-firmar.module').then(m => m.DocumentosPorFirmarModule),
    data: {
      breadcrumb: "Documentos por firmar"
    }
  },
  {
    path: 'ultimos-lotes-completados',
    loadChildren: () => import('../../components/ultimos-lotes-completados/ultimos-lotes-completados.module').then(m => m.UltimosLotesCompletadosModule),
    data: {
      breadcrumb: "Ultimos lotes completados"
    }
  },
  {
    path: 'firmas-pendientes-avances',
    loadChildren: () => import('../../components/firmas-pendientes-avance/firmas-pendientes-avance.module').then(m => m.FirmasPendientesAvanceModule),
    data: {
      breadcrumb: "Firmas pendientes / Avances"
    }
  },
  {
    path: 'accesos' , 
    loadChildren: () => import('../../components/accesos/accesos.module').then(m => m.AccesosModule),
    data: {
      breadcrumb: "Accesos"
    }
  },
  {
    path: 'integraciones' , 
    loadChildren: () => import('../../components/integraciones/integraciones.module').then(m => m.IntegracionesModule),
    data: {
      breadcrumb: "Integraciones"
    }
  },
  
];